import { axios } from "~/plugins/request"

export const state = () => {
    return {}
}
export const mutations = {}
export const actions = {
    findByList({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/workPlanWeek/findByList`, params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    findById({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/workPlanWeek/findById`, params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    save({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/workPlanWeek/save`, params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    planFindByList({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/workPlanTemplate/findByList`, params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    getTitle({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.get(`/workPlanWeek/getTitle`)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    delete({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/workPlanWeek/delete`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    approval({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post('/workPlanWeek/approveStart', params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    callBack({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post('/workPlanWeek/processRecallStart', params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    importExcel({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post('/operationExcel/importExcel', params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    // exportWorkPlan({ commit }, params) {
    //     return new Promise((resolve, reject) => {
    //       axios
    //         .post(`/exportExcel/exportWorkPlan?id=${params.id}&type=${params.type}`)
    //         .then(response => {
    //           resolve(response);
    //         })
    //         .catch(error => {
    //           reject(error);
    //         });
    //     });
    //   },

    exportWorkPlan({ commit }, params) {
        return new Promise((resolve, reject) => {
          axios({
            method: 'post',
            url: '/exportExcel/exportWorkPlan',
            params: params,
            responseType: 'blob',
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(response => {
            resolve(response)
          }).catch((error) => {
            reject(error)
          })
        })
      },







}
